let TagColor = /*#__PURE__*/function (TagColor) {
  TagColor["PRIMARY"] = "primary";
  TagColor["SECONDARY"] = "secondary";
  TagColor["ERROR"] = "error";
  TagColor["SUCCESS"] = "success";
  TagColor["ALERT"] = "alert";
  TagColor["INFO"] = "info";
  TagColor["BLACK"] = "black";
  TagColor["GRAY"] = "gray";
  return TagColor;
}({});

export { TagColor };
//# sourceMappingURL=color.js.map
